// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function fromString(str) {
  return {
          TAG: /* Single */0,
          _0: str
        };
}

function fromList(list) {
  return {
          TAG: /* Many */1,
          _0: list
        };
}

function decodeFromString(param) {
  return Relude_Globals.$great$great(Json.Decode.string, (function (param) {
                return Relude_Result.map(fromString, param);
              }), param);
}

var partial_arg = Curry._1(Json.Decode.list, Json.Decode.string);

function decodeFromMany(param) {
  return Relude_Globals.$great$great(partial_arg, (function (param) {
                return Relude_Result.map(fromList, param);
              }), param);
}

function decode(json) {
  return Curry._2(Json.Decode.$less$pipe$great, decodeFromString(json), decodeFromMany(json));
}

function encode(x) {
  if (x.TAG === /* Single */0) {
    return x._0;
  } else {
    return Json.Encode.list(function (prim) {
                  return prim;
                })(x._0);
  }
}

exports.fromString = fromString;
exports.fromList = fromList;
exports.decodeFromString = decodeFromString;
exports.decodeFromMany = decodeFromMany;
exports.decode = decode;
exports.encode = encode;
/* partial_arg Not a pure module */
